import { render } from "./ExpandTransition.vue?vue&type=template&id=6c348401"
import script from "./ExpandTransition.vue?vue&type=script&lang=js"
export * from "./ExpandTransition.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mayo/htdocs/halp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__